import React from 'react';
import { CacheProvider } from '@emotion/react';
import { StaticRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SharedApp from './SharedApp';
import theme from '../themes/defaultTheme';
var ServerApp = function (_a) {
    var data = _a.data, cache = _a.cache, location = _a.location, _b = _a.queryParams, queryParams = _b === void 0 ? {} : _b;
    return (React.createElement(CacheProvider, { value: cache },
        React.createElement(ThemeProvider, { theme: theme },
            React.createElement(CssBaseline, null),
            React.createElement(StaticRouter, { context: queryParams, location: location },
                React.createElement(SharedApp, { data: data })))));
};
export default ServerApp;
